var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.supporter
    ? _c(
        "div",
        { staticClass: "section" },
        [
          _c("div", { staticClass: "head" }, [
            _c("div", { staticClass: "title" }, [
              _c("h3", [_vm._v("Supporter Details")]),
              _c("p", { staticClass: "sub-title" }, [
                _vm._v(
                  " Created: " +
                    _vm._s(
                      _vm._f("date")(
                        _vm.supporter.createdAt,
                        "dd-MM-yyyy HH:mm"
                      )
                    ) +
                    " - Last Updated: " +
                    _vm._s(
                      _vm._f("date")(
                        _vm.supporter.updatedAt,
                        "dd-MM-yyyy HH:mm"
                      )
                    ) +
                    " "
                )
              ])
            ])
          ]),
          _c("div", { staticClass: "body halved" }, [
            _c("div", { staticClass: "details" }, [
              _c("div", { staticClass: "intro" }, [
                _c("h4", [_vm._v("General Information")]),
                _vm.canEdit
                  ? _c(
                      "a",
                      {
                        staticClass: "edit",
                        on: {
                          click: function($event) {
                            return _vm.open(_vm.modalNames.EDIT_DETAILS)
                          }
                        }
                      },
                      [_vm._v("Edit Details")]
                    )
                  : _vm._e()
              ]),
              _c("dl", { staticClass: "fields desc" }, [
                _c("div", { staticClass: "field" }, [
                  _c("dt", { staticClass: "label" }, [_vm._v("Title")]),
                  _c("dd", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.supporter.title || " "))
                  ])
                ]),
                _c("div", { staticClass: "field" }, [
                  _c("dt", { staticClass: "label" }, [_vm._v("First Name")]),
                  _c("dd", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.supporter.firstName))
                  ])
                ]),
                _c("div", { staticClass: "field" }, [
                  _c("dt", { staticClass: "label" }, [_vm._v("Last Name")]),
                  _c("dd", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.supporter.lastName))
                  ])
                ])
              ])
            ]),
            _c("div", { staticClass: "details" }, [
              _vm._m(0),
              _c("dl", { staticClass: "fields desc" }, [
                _c("div", { staticClass: "field" }, [
                  _c("dt", { staticClass: "label" }, [_vm._v("Pandata ID")]),
                  _c("dd", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.supporter.id))
                  ])
                ]),
                _c("div", { staticClass: "field" }, [
                  _c("dt", { staticClass: "label" }, [_vm._v("SSO ID")]),
                  _c("dd", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.supporter.ssoId))
                  ])
                ]),
                _c("div", { staticClass: "field" }, [
                  _c("dt", { staticClass: "label" }, [
                    _vm._v("Raiser's Edge ID")
                  ]),
                  _c("dd", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.supporter.reConstituentId))
                  ])
                ]),
                _c("div", { staticClass: "field" }, [
                  _c("dt", { staticClass: "label" }, [_vm._v("Marketo ID")]),
                  _c("dd", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.supporter.marketoLeadId))
                  ])
                ])
              ])
            ])
          ]),
          _c(
            "div",
            { staticClass: "body halved" },
            [
              _c("SupporterViewPhones", {
                attrs: { canEdit: _vm.canEdit, contacts: _vm.phones },
                on: { addContact: _vm.addContact, editContact: _vm.editContact }
              }),
              _c("SupporterViewEmails", {
                attrs: { canEdit: _vm.canEdit, contacts: _vm.emails },
                on: { addContact: _vm.addContact, editContact: _vm.editContact }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "body" },
            [
              _c("SupporterViewAddresses", {
                attrs: {
                  canEdit: _vm.canEdit,
                  supporter: _vm.supporter,
                  addresses: _vm.supporter.addresses
                }
              })
            ],
            1
          ),
          _vm.isOpen(_vm.modalNames.EDIT_DETAILS)
            ? _c("SupporterEditDetails", {
                attrs: { supporter: _vm.supporter }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "intro" }, [
      _c("h4", [_vm._v("Identifiers")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }